import React from 'react'
import { MaxAppWidth } from '@ally/next-layout'
import { SnackbarProvider, TextHeading, get } from '@ally/metronome-ui'
import { Switch, Route } from 'react-router-dom'
import styled from 'styled-components'
import { Beneficiaries } from '../components/Beneficiaries'

const StyledHeading = styled(TextHeading)`
  padding-bottom: ${get.space('lg')};
`

export const Router: React.FC = () => {
  return (
    <MaxAppWidth py="md">
      <Switch>
        <Route
          path={[
            '/beneficiaries',
            '/beneficiaries/deposit',
            '/beneficiaries/ira',
            '/beneficiaries/invest',
          ]}
        >
          <>
            <StyledHeading
              tag="h1"
              size="lg"
              weight="bold"
              focusOnMount
              dataAnchorId="beneficiaries"
              id="beneficiaries"
            >
              Beneficiaries
            </StyledHeading>
            <SnackbarProvider>
              <Beneficiaries />
            </SnackbarProvider>
          </>
        </Route>
      </Switch>
    </MaxAppWidth>
  )
}

export default Router
